module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.0d92fc08.eot";